import { GB, DE, FR, IT, ES, PT, NO } from "country-flag-icons/react/3x2";

const FLAG_COMPONENTS = { GB, DE, FR, IT, ES, PT, NO };

export default function FlagIcon({ code, className = "", ...props }) {
  const Flag = FLAG_COMPONENTS[code];
  if (!Flag) return null;
  return (
    <Flag
      aria-hidden="true"
      className={`inline-block w-5 h-auto align-middle ${className}`}
      {...props}
    />
  );
}

